import { format } from "date-fns";
import { Fragment, useMemo } from "react";
import type { ZypeSubscription } from "@inferno/renderer-shared-core";
import { Button, ButtonKind } from "../../../../../../core/ui";
import { getSubscriptionDisplayStatus, isGiftSubscription } from "../../../../lib/coastUser";

const getSubscriptionName = (s: ZypeSubscription) =>
  `${s.plan_name} for $${s.amount} ${getSubscriptionDisplayStatus(s)}`;

interface CoastAccountSubscriptionProps {
  subscription: ZypeSubscription;
  onEdit: (subscription: ZypeSubscription) => void;
}

export function CoastUserSubscription({ subscription, onEdit }: CoastAccountSubscriptionProps) {
  const endDate = useMemo(() => format(new Date(subscription.current_period_end_at), "MMMM dd, yyyy"), [subscription]);
  const name = useMemo(() => getSubscriptionName(subscription), [subscription]);
  const isEditable = useMemo(() => isGiftSubscription(subscription), [subscription]);

  return (
    <Fragment>
      <div className="component-account-subscription">
        <div className="content">
          <p>
            <strong>Plan: </strong>
            {name}
          </p>
          <p>
            <strong>Next Bill: </strong>
            {endDate}
          </p>
        </div>

        <Button
          click={() => onEdit(subscription)}
          disabled={isEditable}
          kind={ButtonKind.SECONDARY}
          className="account-button"
        >
          Change or Cancel Plan
        </Button>
      </div>
    </Fragment>
  );
}
